import { matchPath } from 'react-router'

export enum Pages {
  CHATTING_UI = '/chatting-ui/:creatorId',
  WELCOME_MESSAGES_OPTIONS = '/c/:creatorId/settings/welcome-messages',
  WELCOME_MESSAGES_CREATE = '/c/:creatorId/settings/welcome-messages/create',
  WELCOME_MESSAGES_EDIT = '/c/:creatorId/settings/welcome-messages/edit/:messageId',
  CREATOR_BASED_PATH = '/c/:creatorId/*',
  BLACKLISTED_WORDS = '/blacklisted-words',
  BLACKLISTED_WORDS_LOGS = '/blacklisted-words/logs',

  // Auth routes
  LOGIN = '/login',
  REGISTER = '/register',
  REGISTER_AFTER_PAYMENT = '/register-after-payment',
  RESET_PASSWORD = '/reset-password',
  RESET_PASSWORD_WITH_TOKEN = '/reset-password/:token',
  ACTIVATE_ACCOUNT = '/team/activate',

  // Main routes
  HOME = '/',
  OVERVIEW = '/overview',
  CHATTER_LEADERBOARD_BROWSER = '/overview/chatter-leaderboard/browser/:name',
  CHATTER_LEADERBOARD_USER = '/overview/chatter-leaderboard/user/:userId',

  // Tasks
  TASKS = '/tasks',
  TASK_DETAILS = '/tasks/:id',

  // Courses
  COURSES = '/courses',
  COURSE_DETAILS = '/courses/:category',

  // Prospects
  PROSPECTS = '/prospects',

  // Creators
  CREATORS = '/creators',
  CREATOR_ACCESS = '/creators/:id/access',

  // Teams
  TEAM = '/team',
  TEAM_MEMBERS = '/team/members',
  TEAM_MEMBER_DETAILS = '/team/members/:id',
  TEAM_ROLES = '/team/roles',
  TEAM_ROLE_EDIT = '/team/roles/:roleId',

  // Shifts
  SHIFTS = '/shifts',
  SHIFTS_HISTORY = '/shifts/history',

  // Profile
  PROFILE_SETTINGS = '/profile/settings',
  PROFILE_PREFERENCES = '/profile/preferences',
  PROFILE_SECURITY = '/profile/security',
  PROFILE_ABOUT = '/profile/about-us',

  // Creator specific routes
  CREATOR_TRACKING_NEW_SUBSCRIBER = '/c/:creatorId/tracking/new-subscriber-analysis',
  CREATOR_TRACKING_CHATTER = '/c/:creatorId/tracking/chatter',
  CREATOR_TRACKING_CHATTER_DETAILS = '/c/:creatorId/tracking/chatter/:name/:id',
  CREATOR_TRACKING_PPV = '/c/:creatorId/tracking/ppv',
  CREATOR_TRACKING_PPV_DETAILS = '/c/:creatorId/tracking/ppv/:categoryIndex',
  CREATOR_TRACKING_PPV_MESSAGES = '/c/:creatorId/tracking/ppv/:categoryIndex/messages/:mediaSetIndex',
  CREATOR_TRACKING_LINKS = '/c/:creatorId/tracking/links',
  CREATOR_TRACKING_LINKS_DETAILS = '/c/:creatorId/tracking/links/:linkId',
  CREATOR_TRACKING_FREE_TRIAL_LINKS = '/c/:creatorId/tracking/free-trial-links',
  CREATOR_TRACKING_FREE_TRIAL_LINKS_DETAILS = '/c/:creatorId/tracking/free-trial-links/:linkId',
  CREATOR_TRACKING_MESSAGE_HISTORY = '/c/:creatorId/tracking/message-history',
  CREATOR_TRACKING_FUNNEL = '/c/:creatorId/tracking/funnel',
  CREATOR_TRACKING_FUNNEL_DETAILS = '/c/:creatorId/tracking/funnel/:funnelId',
  CREATOR_TIKTOK_RESEARCH_VIDEOS = '/c/:creatorId/tiktok/videos',
  CREATOR_TIKTOK_RESEARCH_SOUNDS = '/c/:creatorId/tiktok/sounds',
  CREATOR_TIKTOK_RESEARCH_SOUND_PAGE = '/c/:creatorId/tiktok/sounds/:soundId/trending-videos',
  CREATOR_TIKTOK_RESEARCH_LISTS = '/c/:creatorId/tiktok/lists',
  CREATOR_TIKTOK_RESEARCH_LIST_PAGE = '/c/:creatorId/tiktok/lists/:id',

  // Creator statistics
  CREATOR_STATISTICS_TIKTOK = '/c/:creatorId/statistics/tiktok',
  CREATOR_STATISTICS_TIKTOK_ACCOUNTS = '/c/:creatorId/statistics/tiktok/accounts',
  CREATOR_STATISTICS_ONLYFANS = '/c/:creatorId/statistics/onlyfans',
  CREATOR_STATISTICS_IG_REELS = '/c/:creatorId/statistics/ig-reels',
  CREATOR_STATISTICS_IG_REELS_ACCOUNTS = '/c/:creatorId/statistics/ig-reels/accounts',

  // Creator AI features
  CREATOR_AI_SETTINGS = '/c/:creatorId/ai-features/settings',
  CREATOR_AICH_ALPHA = '/c/:creatorId/ai-features/aich',
  // Creator settings
  CREATOR_SETTINGS_AUTOMATIONS = '/c/:creatorId/settings/automations',
  CREATOR_SETTINGS_AUTO_FOLLOW = '/c/:creatorId/settings/automations/auto-follow',
  CREATOR_SETTINGS_FAN_NUMBERING = '/c/:creatorId/settings/automations/fan-numbering',
  CREATOR_SETTINGS_PROMOTION = '/c/:creatorId/settings/automations/promotion',

  // Creator scripts
  CREATOR_SCRIPTS = '/c/:creatorId/settings/scripts',
  CREATOR_SCRIPTS_CREATE = '/c/:creatorId/settings/scripts/create',
  CREATOR_SCRIPTS_EDIT = '/c/:creatorId/settings/scripts/:id/edit',

  // Creator messages settings
  CREATOR_PPV_FOLLOW_UP_MESSAGES = '/c/:creatorId/settings/ppv-follow-up-messages',
  CREATOR_REBILL_MESSAGES = '/c/:creatorId/settings/rebill-messages',
  CREATOR_REBILL_MESSAGES_CREATE = '/c/:creatorId/settings/rebill-messages/create',
  CREATOR_REBILL_MESSAGES_EDIT = '/c/:creatorId/settings/rebill-messages/edit/:id',
  CREATOR_ONLINE_MASS_MESSAGES = '/c/:creatorId/settings/online-mass-messages',
  CREATOR_ONLINE_MASS_MESSAGES_CREATE = '/c/:creatorId/settings/online-mass-messages/create',
  CREATOR_EXPIRING_FANS = '/c/:creatorId/settings/expiring-fans',

  // Creator lists settings
  CREATOR_LISTS = '/c/:creatorId/settings/lists',
  CREATOR_SPENDING_LISTS = '/c/:creatorId/settings/lists/spending-lists',
  CREATOR_NEW_SUBS_LIST = '/c/:creatorId/settings/lists/new-subs-list',
  CREATOR_NO_SPENDERS = '/c/:creatorId/settings/lists/no-spenders',
  CREATOR_RECENT_SPENDERS = '/c/:creatorId/settings/lists/recent-spenders',
  CREATOR_SHARED_FOLLOWERS = '/c/:creatorId/settings/lists/shared-followers',
  CREATOR_CUSTOM_LISTS = '/c/:creatorId/settings/lists/custom-lists',

  // Creator other settings
  CREATOR_DISPLAY_SETTINGS = '/c/:creatorId/settings/display',
  CREATOR_AUTOMATION_SETTINGS = '/c/:creatorId/settings/automation',
  CREATOR_VISIBILITY_SETTINGS = '/c/:creatorId/settings/visibility',
  CREATOR_VAULT = '/c/:creatorId/settings/vault',

  // Licenses
  LICENSES = '/licenses',
  YOUR_LICENSES = '/licenses/your-licenses',

  // Help
  VIP_SUPPORT = '/vip-support',

  // Accounting
  ACCOUNTING = '/accounting',
}

// page cannot be redirected to CUI during runtime, so it will be CUI from the start
export const isCUI = !!matchPath(Pages.CHATTING_UI, window.location.pathname)
